import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryNav from '@/pages/home/components/CategoryNav';
import HotRecommend from '@/pages/home/components/HotRecommend';
import LatestUpdate from '@/pages/home/components/LatestUpdate';
import FAQSection from '@/pages/home/components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <HotRecommend />
          <LatestUpdate />
          <FAQSection />
        </article>
      </main>
      <Footer />
    </>
  );
}